import { t } from 'bv-i18n';

const GameDisabled = () => (
  <div className="casino-game__disabled-backsoon">
    {t('javascript.casino.back_soon')}
  </div>
);

export default GameDisabled;
